// extracted by mini-css-extract-plugin
export default {"checkbox":"HeaderCheckbox_checkbox__1Oi1T"};